import {
    DoubleSide,
    Mesh,
    MeshPhongMaterial,
    MeshStandardMaterial,
    PlaneGeometry,
    sRGBEncoding,
    TextureLoader,
} from "three";

const footerWatermarkImageSrc = new URL("../assets/images/footerWatermark.png", import.meta.url).href;
const sesameStreetImageSrc = new URL("../assets/images/sesameStreetLogo.png", import.meta.url).href;

let aspect = window.innerWidth / window.innerHeight;
let h = 500 / 200;
let w = h * aspect;

let footerWatermark;
let sesameLogo;

export function initWatermarks(scene: THREE.Scene) {
    let footerWatermarkTexture = new TextureLoader().load(footerWatermarkImageSrc);
    footerWatermarkTexture.encoding = sRGBEncoding;
    footerWatermark = new Mesh(
        new PlaneGeometry(1, 1),
        new MeshStandardMaterial({
            map: footerWatermarkTexture,
            transparent: true,
            side: DoubleSide,
        })
    );
    footerWatermark.scale.set(0.4, 0.08, 1);
    footerWatermark.position.set(0, -0.254, -0.5);
    scene.add(footerWatermark);

    let sesameLogoTexture = new TextureLoader().load(sesameStreetImageSrc);
    sesameLogoTexture.encoding = sRGBEncoding;
    sesameLogo = new Mesh(
        new PlaneGeometry(1, 1),
        new MeshPhongMaterial({
            map: sesameLogoTexture,
            transparent: true,
            side: DoubleSide,
        })
    );
    sesameLogo.scale.set(0.15, 0.075, 1);
    sesameLogo.position.set(0, 0.22, -0.5);
    scene.add(sesameLogo);
}

// export function toggleWatermark() {
//   watermark.visible = !watermark.visible;
//   footerWatermark.visible = !footerWatermark.visible;
// }
